import { ProductModel } from '../models/product.model';
import { PrestationModel } from '../models/prestation.model';

type CatalogReference = Partial<ProductModel | PrestationModel> | null | undefined;

export function hasDocumentation(reference: CatalogReference): boolean {
  return Boolean(reference?.generalSupplierCatalog || reference?.technicalSheet || reference?.safetyUsageProtocol);
}

/** Libellé, référence et fournisseur sont déjà des colonnes du catalogue : seul le reste justifie la modale. */
export function hasMoreInfo(reference: CatalogReference): boolean {
  return Boolean(reference?.comment || hasDocumentation(reference));
}
